import http from 'utils/http';

export const fetchMerchantsReport = ({ query, page }) => http.get(`v1/organizations/{{organizationId}}/reporting/merchants/?page=${page}&${query}`).then((res) => res.data);
